import { URI_GUARD_REQUEST } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  let path = `${URI_GUARD_REQUEST}guard-histories`;
  if (payload) {
    const query = Object.keys(payload)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(payload[k])}`)
      .join('&');

    path += `?${query}`;
  }

  const response = await fetch(path, opts);

  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    return Promise.reject(jsonResult.message);
  }
  return jsonResult.data;
};
